import {CALL_API} from '../../middleware/api'

// 招聘管理
// list
export const RECRUITMENT_LIST_REQUEST = 'RECRUITMENT_LIST_REQUEST'
export const RECRUITMENT_LIST_SUCCESS = 'RECRUITMENT_LIST_SUCCESS'
export const RECRUITMENT_LIST_FAILURE = 'RECRUITMENT_LIST_FAILURE'

// 添加
export const RECRUITMENT_INSERT_REQUEST = 'RECRUITMENT_INSERT_REQUEST'
export const RECRUITMENT_INSERT_SUCCESS = 'RECRUITMENT_INSERT_SUCCESS'
export const RECRUITMENT_INSERT_FAILURE = 'RECRUITMENT_INSERT_FAILURE'

// 更新
export const RECRUITMENT_UPDATE_REQUEST = 'RECRUITMENT_UPDATE_REQUEST'
export const RECRUITMENT_UPDATE_SUCCESS = 'RECRUITMENT_UPDATE_SUCCESS'
export const RECRUITMENT_UPDATE_FAILURE = 'RECRUITMENT_UPDATE_FAILURE'

// 删除
export const RECRUITMENT_DELETE_REQUEST = 'RECRUITMENT_DELETE_REQUEST'
export const RECRUITMENT_DELETE_SUCCESS = 'RECRUITMENT_DELETE_SUCCESS'
export const RECRUITMENT_DELETE_FAILURE = 'RECRUITMENT_DELETE_FAILURE'

// 获取list
export function getRecruitmentList() {
	return {
		[CALL_API]: {
			types: [RECRUITMENT_LIST_REQUEST, RECRUITMENT_LIST_SUCCESS, RECRUITMENT_LIST_FAILURE],
			endpoint: '/recruitment/list'
		}
	}
}

// 添加
export function addRecruitment(params) {
	return {
		[CALL_API]: {
			types: [RECRUITMENT_INSERT_REQUEST, RECRUITMENT_INSERT_SUCCESS, RECRUITMENT_INSERT_FAILURE],
			endpoint: '/recruitment/insert',
			methods: 'POST',
			params
		}
	}
}

// 更新
export function updateRecruitment(params) {
	return {
		[CALL_API]: {
			types: [RECRUITMENT_UPDATE_REQUEST, RECRUITMENT_UPDATE_SUCCESS, RECRUITMENT_UPDATE_FAILURE],
			endpoint: '/recruitment/update',
			methods: 'POST',
			params
		}
	}
}

// 删除新闻
export function deleteRecruitment(id) {
	return {
		[CALL_API]: {
			types: [RECRUITMENT_DELETE_REQUEST, RECRUITMENT_DELETE_SUCCESS, RECRUITMENT_DELETE_FAILURE],
			endpoint: `/recruitment/delete?id=${id}`,
		}
	}
}


// WEBPACK FOOTER //
// ./src/action/content/recruitment.js